import { Component, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ScannerFacade } from '../+state';

@Injectable()
export class CloseScannerGuard implements CanDeactivate<Component> {
  constructor(private scannerFacade: ScannerFacade) {}

  public canDeactivate(): boolean {
    this.scannerFacade.closeScannerCamera();
    return true;
  }
}
